import React from "react";

function Cv(){
    return (
        <div class="mx-auto justify-content-center">
            <h5 class="mx-auto p-5">You caught me! this page is still under development.</h5>
            <h3 class="mx-auto p-5"> But you can take a look at my <a
            target="_blank"
            rel="noopener noreferrer"
            className="inTextA"
            href="https://drive.google.com/file/d/1buCv93p1V7oeaK_rX7KVqS-qsrAj1Ppy/view?usp=share_link">
            CV
          </a> in a traditional form.</h3>
        </div>
    )
}

export default Cv;